import script from "./PopupPreviewCours.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupPreviewCours.vue?vue&type=script&setup=true&lang=js"

import "./PopupPreviewCours.vue?vue&type=style&index=0&id=40559698&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40559698"]])

export default __exports__